/// <reference types="vite/client" />
import * as Sentry from "@sentry/tanstackstart-react";
import { createRouter as createTanstackRouter } from "@tanstack/react-router";
import { routerWithQueryClient } from "@tanstack/react-router-with-query";

import { routeTree } from "./routeTree.gen";

import "./styles.css";
import * as TanstackQuery from "@/components/integrations/tanstack-query/root-provider";
import { ErrorPage } from "./components/error-page";
import { LoadingSpinner } from "./components/loadingComponent";
import { NotFoundPage } from "./components/not-found-page";

// Create a new router instance
export function getRouter() {
  const router = createTanstackRouter({
    routeTree,
    context: { ...TanstackQuery.getContext() },
    defaultPreload: false,
    defaultPreloadStaleTime: 0,
    defaultErrorComponent: ErrorPage,
    defaultNotFoundComponent: () => <NotFoundPage />,
    scrollRestoration: true,
    defaultPendingComponent: () => <LoadingSpinner />,
    defaultStructuralSharing: true,
  });

  if (!router.isServer) {
    const isDev = import.meta.env.DEV;
    const stage = import.meta.env.VITE_APP_STAGE || "production";
    const tracesSampleRate = isDev || stage === "staging" ? 1.0 : 0.1;

    Sentry.init({
      dsn: "https://d93b1707b8f4f684f9748544d9187dcb@o4511473931190272.ingest.de.sentry.io/4511474177146960",
      enabled: !isDev,
      sendDefaultPii: true,
      environment: isDev ? "development" : stage,
      integrations: [
        Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
        Sentry.tanstackRouterBrowserTracingIntegration(router),
      ],
      enableLogs: !!isDev,
      tracesSampleRate,
    });
  }

  return routerWithQueryClient(router, TanstackQuery.getContext().queryClient);
}

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
